/**
 * Enumération des types de push notification
 */
export enum TypePushNotification {
    NON_DEFINI = 'NON_DEFINI',
    VALIDATION_NDF = 'VALIDATION_NDF',
    REJET_NDF = 'REJET_NDF',
    A_TRAITER_NDF = 'A_TRAITER_NDF',
    REJET_DEPENSE = 'REJET_DEPENSE',
    VALIDATION_OD = 'VALIDATION_OD',
    REJET_OD = 'REJET_OD',
    A_TRAITER_OD = 'A_TRAITER_OD'
}